import { RadioProps } from '..';
import React from 'react';
import clsx from 'clsx';
import { useCustomComponent } from '@/hooks';

export interface RadioContainerProps extends RadioProps {
  children: React.ReactNode;
}
const ContainerComponent: React.FC<RadioContainerProps> = ({
  className,
  children,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedby,
}) => {
  return (
    <div
      className={clsx('peptalk-radio', className)}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedby}
    >
      {children}
    </div>
  );
};

export const Container: React.FC<RadioContainerProps> = (
  props: RadioContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'RadioContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
